import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { rtkQueryErrorLogger } from './slices';
import { authAPI } from './slices/auth';
import { icardioAPI } from './slices/icardio';

export const store = configureStore({
  reducer: {
    [authAPI.reducerPath]: authAPI.reducer,
    [icardioAPI.reducerPath]: icardioAPI.reducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({ serializableCheck: false }).concat(
      authAPI.middleware,
      icardioAPI.middleware,
      rtkQueryErrorLogger
    ),
});

setupListeners(store.dispatch);
